module.exports = __webpack_public_path__ + "static/media/template3-carousel.6e659810.webp";